import styled from 'styled-components';

// CONSTANTS
import { SANTAS_GRAY } from '@/constants/colors';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

export const Container = styled.div`
  min-height: 100vh;
  padding: 70px 0;
  display: flex;
  justify-content: center;
  align-items: center;

  .not-found {
    &__img {
      display: block;
      width: 100%;
      max-width: 570px;
      margin: 0 auto 60px;

      ${breakpoints.down('xs')} {
        margin-bottom: 25px;
      }
    }

    &__subtitle {
      a {
        font-weight: 400;
      }
    }

    &__search {
      .MuiOutlinedInput-adornedEnd {
        padding-right: 0;
      }

      .MuiOutlinedInput-inputAdornedEnd {
        padding-right: 1.5rem;
      }

      input {
        &::-webkit-input-placeholder {
          color: ${SANTAS_GRAY};
        }
      }

      button {
        min-width: 135px;
        border-radius: 0 3px 3px 0;
        padding-top: 14px;
        padding-bottom: 14px;

        ${breakpoints.down('xs')} {
          min-width: 92px;
        }
      }
    }
  }

  &.not-found {
    &--partner {
      .not-found__subtitle {
        span {
          display: none;
        }
      }
    }
  }
`;

export default Container;
